import classNames from 'classnames/bind';
import React from 'react';

import styles from './MiniTable.module.scss';

const cx = classNames.bind(styles);

const MiniTable = ({ title, data }) => {
  return (
    <div className={cx('container')}>
      <div className={cx('title')}>{title}</div>
      <table cellSpacing={0}>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.label}</td>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MiniTable;
